import { type MutableCollabFilter } from '@databases/model/views/view-filter';
import { type DatabaseFilter } from '@databases/types/database/view';

import { isUsageFilter, type UsageFilter } from './isUsageFilter.ts';

export function getFilterById(
  filters: MutableCollabFilter[] | DatabaseFilter[],
  id: string
): [MutableCollabFilter | DatabaseFilter, number] | undefined {
  for (let filterIndex = 0; filterIndex < filters.length; filterIndex++) {
    const currentFilter = filters[filterIndex];
    if (currentFilter.id === id) {
      return [currentFilter, filterIndex];
    } else if (isUsageFilter(currentFilter)) {
      const nestedResult = getFilterById(currentFilter.value, id);
      if (nestedResult) {
        return nestedResult;
      }
    }
  }

  return undefined;
}

export function getParentByChildId(
  parentFilter: UsageFilter,
  childId: string
): UsageFilter | undefined {
  const filters = parentFilter.value;

  for (let filterIndex = 0; filterIndex < filters.length; filterIndex++) {
    const currentFilter = filters[filterIndex];

    if (currentFilter.id === childId) {
      return parentFilter;
    } else if (isUsageFilter(currentFilter)) {
      const nestedResult = getParentByChildId(currentFilter, childId);
      if (nestedResult) {
        return nestedResult;
      }
    }
  }

  return undefined;
}
